import infoMessagesFlag from "../../../../src/pages/foundations/content/designing-messages/info-messages/_assets/info-messages-flag.png";
import infoMessagesEmptyState from "../../../../src/pages/foundations/content/designing-messages/info-messages/_assets/info-messages-empty-state.png";
import * as React from 'react';
export default {
  infoMessagesFlag,
  infoMessagesEmptyState,
  React
};